import { isArray } from 'lodash'

/**
 * Parse array from string format used in budgeting method source
 * Extracts array from a string containing array notation like: 'account([3000,3100], current)'
 *
 * @param inputString - String containing array notation with brackets, or already an array
 * @returns Parsed array, or null if no valid array found
 *
 * @example
 * parseArrayFromString('account([3000,3100], current)') // => [3000, 3100]
 * parseArrayFromString('[1,2,3]') // => [1, 2, 3]
 * parseArrayFromString([1,2,3]) // => [1, 2, 3] (returns as-is if already array)
 * parseArrayFromString('no array here') // => null
 */
export const parseArrayFromString = (inputString = '') => {
  // Use a regular expression to extract the part within the parentheses
  if (isArray(inputString)) return inputString
  const match = inputString?.match(/\[([^)]+)\]/)
  if (match) {
    const arrayString = match[1] // Extract the content within the parentheses
    try {
      const array = JSON.parse(`[${arrayString}]`)
      return array
    } catch (error) {
      return null
    }
  }
  return null // Return null if no array is found
}
